import { apiFetch } from "../auth/apiClient";

export const boardApi = {
  listCurrent: () =>
    apiFetch("/api/board/members", { method: "GET", authRequired: true }),
  listPast: () =>
    apiFetch("/api/board/members/past", { method: "GET", authRequired: true }),
  listElders: () =>
    apiFetch("/api/board/elders", { method: "GET", authRequired: true }),
  listPastElders: () =>
    apiFetch("/api/board/elders/past", { method: "GET", authRequired: true }),
  listRoles: () =>
    apiFetch("/api/board/roles", { method: "GET", authRequired: true }),
  getRole: (role) =>
    apiFetch(`/api/board/roles/${role}`, {
      method: "GET",
      authRequired: true,
    }),
  listEligibleOwners: (q) => {
    const qs = q ? `?q=${encodeURIComponent(q)}` : "";
    return apiFetch(`/api/board/eligible-primary-owners${qs}`, {
      method: "GET",
      authRequired: true,
    });
  },
  createMember: (body) =>
    apiFetch("/api/board/members", {
      method: "POST",
      authRequired: true,
      body,
    }),
  patchMember: (id, body) =>
    apiFetch(`/api/board/members/${id}`, {
      method: "PATCH",
      authRequired: true,
      body,
    }),
  deleteMember: (id) =>
    apiFetch(`/api/board/members/${id}`, {
      method: "DELETE",
      authRequired: true,
    }),
  createElder: (body) =>
    apiFetch("/api/board/elders", {
      method: "POST",
      authRequired: true,
      body,
    }),
  patchElder: (id, body) =>
    apiFetch(`/api/board/elders/${id}`, {
      method: "PATCH",
      authRequired: true,
      body,
    }),
  deleteElder: (id) =>
    apiFetch(`/api/board/elders/${id}`, {
      method: "DELETE",
      authRequired: true,
    }),

  // ===== Volunteer Teams =====
  listTeams: () =>
    apiFetch("/api/board/teams", { method: "GET", authRequired: true }),
  getTeam: (slug) =>
    apiFetch(`/api/board/teams/${slug}`, {
      method: "GET",
      authRequired: true,
    }),
  createTeam: (body) =>
    apiFetch("/api/board/teams", {
      method: "POST",
      authRequired: true,
      body,
    }),
  patchTeam: (slug, body) =>
    apiFetch(`/api/board/teams/${slug}`, {
      method: "PATCH",
      authRequired: true,
      body,
    }),
  // Legacy alias — same effect as joinTeam now.
  applyToTeam: (slug, note) =>
    apiFetch(`/api/board/teams/${slug}/join`, {
      method: "POST",
      authRequired: true,
      body: { note: note || null },
    }),
  joinTeam: (slug, note) =>
    apiFetch(`/api/board/teams/${slug}/join`, {
      method: "POST",
      authRequired: true,
      body: { note: note || null },
    }),
  leaveTeam: (slug, reason) =>
    apiFetch(`/api/board/teams/${slug}/leave`, {
      method: "POST",
      authRequired: true,
      body: { reason: reason || null },
    }),
  listPendingApplications: () =>
    apiFetch("/api/board/teams/applications/pending", {
      method: "GET",
      authRequired: true,
    }),
  approveApplication: (id, note) =>
    apiFetch(`/api/board/teams/applications/${id}/approve`, {
      method: "POST",
      authRequired: true,
      body: { note: note || null },
    }),
  rejectApplication: (id, note) =>
    apiFetch(`/api/board/teams/applications/${id}/reject`, {
      method: "POST",
      authRequired: true,
      body: { note: note || null },
    }),
  promoteLead: (slug, userId) =>
    apiFetch(`/api/board/teams/${slug}/members/${userId}/promote-lead`, {
      method: "POST",
      authRequired: true,
      body: {},
    }),
  removeMember: (slug, userId) =>
    apiFetch(`/api/board/teams/${slug}/members/${userId}/remove`, {
      method: "POST",
      authRequired: true,
      body: {},
    }),
  // Admin: typeahead for residents to add to a team, then direct add.
  searchTeamCandidates: (q) =>
    apiFetch(`/api/board/teams/member-search?q=${encodeURIComponent(q)}`, {
      method: "GET",
      authRequired: true,
    }),
  addTeamMember: (slug, userId) =>
    apiFetch(`/api/board/teams/${slug}/members`, {
      method: "POST",
      authRequired: true,
      body: { user_id: userId },
    }),
};
